<app-selector
  label="Pool Game"
  [isEmptySelectable]="isEmptySelectable"
  [data]="poolGameCoreService.poolGameList$ | async"
  displayKey="name"
  [formControl]="ctrl"
  (refreshEvent)="refresh()"
  hintStyle="margin-left: -14px; margin-top: -5px"
  [loading]="poolGameCoreService.loading$ | async"
  [hint]="hint"
>
</app-selector>
